import { coreOrganizationsAllGetAsyncSlice } from './get';
import { coreOrganizationsAllRemoveSyncSlice } from './remove';
import { coreOrganizationsAllUpdateSyncSlice } from './update';

export const { receiveGetCoreOrganizationsAll, requestGetCoreOrganizationsAll, resetGetCoreOrganizationsAll } =
	coreOrganizationsAllGetAsyncSlice.asyncActionCreators;

export const updateOrganization = coreOrganizationsAllUpdateSyncSlice.syncActionCreator;
export const removeOrganization = coreOrganizationsAllRemoveSyncSlice.syncActionCreator;
